/**
 * @generated SignedSource<<591227197fee2408137a2a9b1880a25b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type RoutineDetailScreenTopTaskIssueCreator_Routine$data = {
  readonly id: string;
  readonly topTaskSectionIssueCreators: ReadonlyArray<{
    readonly count: number;
    readonly id: string;
    readonly section: {
      readonly assignedTeam: {
        readonly icon: TeamIcon | null;
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly title: string | null;
    } | null;
    readonly task: {
      readonly __typename: "TaskCheck";
      readonly id: string;
      readonly title: string;
    } | null;
  }>;
  readonly " $fragmentType": "RoutineDetailScreenTopTaskIssueCreator_Routine";
};
export type RoutineDetailScreenTopTaskIssueCreator_Routine$key = {
  readonly " $data"?: RoutineDetailScreenTopTaskIssueCreator_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineDetailScreenTopTaskIssueCreator_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fromDate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./RoutineDetailScreenTaskIssueRefetch.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "RoutineDetailScreenTopTaskIssueCreator_Routine",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "fromDate",
          "variableName": "fromDate"
        }
      ],
      "concreteType": "TaskSectionIssueStatNode",
      "kind": "LinkedField",
      "name": "topTaskSectionIssueCreators",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "assignedTeam",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "icon",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "task",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v2/*: any*/),
              "type": "TaskCheck",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v2/*: any*/),
              "type": "TaskNumber",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v2/*: any*/),
              "type": "TaskText",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "e95669fa7e4a6b7b5c7c76150649180b";

export default node;
